import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ContainerWithForm } from '../../components/Container';
import MedicareForm from './MedicareCardForm';
import analytics from '../../infra/analytics';
import { MEDICARE_DETAILS, SITE_NAME } from '../../constants/analytics';
import { StylePageTitle } from '../../styles/sharedStyleComponets';

const MedicareDetails: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    analytics.logPageViewEvent(MEDICARE_DETAILS, {
      site: SITE_NAME,
      page_path: pathname,
    });
  }, [pathname]);

  return (
    <ContainerWithForm>
      <StylePageTitle level={2}>
        Medicare Details
      </StylePageTitle>
      <MedicareForm />
    </ContainerWithForm>
  );
};

export default MedicareDetails;
